import { render, staticRenderFns } from "./color-themes.demo.vue?vue&type=template&id=0dfe9c58&"
import script from "./color-themes.demo.vue?vue&type=script&lang=js&"
export * from "./color-themes.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports